import { GET_TEAM_INFO, SET_PLAYERS_FROM_MATCH } from './teamVCard.types';

const initState = {
  players: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    case GET_TEAM_INFO:
      return {
        ...state,
        players: [...action.payload.players],
      };
    case SET_PLAYERS_FROM_MATCH:
      return {
        ...state,
        players: [...action.payload],
      };

    default:
      return state;
  }
};
